import { ReactElement } from 'react';

import { BindingCreator, NumberPatternType } from '@dreryk/react-common';

import { settingsTranslationKeys } from '../../../../translations';
import { DEFAULT_SLOT_BOOKING_LEAD_PERIOD_IN_HOURS } from '../AppointmentRequestsSettingsForm.utils';

import { StyledSlotBookingLeadPeriodInHoursField } from './SlotBookingLeadPeriodInHoursField.styled';

const SHORT_ADVANCE_BOOKING_DURATION_STEP = 1;
const SHORT_ADVANCE_BOOKING_DURATION_MIN_VALUE = 1;
const SHORT_ADVANCE_BOOKING_DURATION_MAX_VALUE = 336; // 2 weeks

type SlotBookingLeadPeriodInHoursFormBeanPart = {
   blockShortAdvanceBooking: boolean;
   slotBookingLeadPeriodInHours: number | null;
};

type SlotBookingLeadPeriodInHoursFieldProps = {
   register: BindingCreator<SlotBookingLeadPeriodInHoursFormBeanPart>;
};

export const SlotBookingLeadPeriodInHoursField = (props: SlotBookingLeadPeriodInHoursFieldProps): ReactElement => {
   return (
      <StyledSlotBookingLeadPeriodInHoursField
         testId={'slotBookingLeadPeriodInHours'}
         controller={props.register('slotBookingLeadPeriodInHours', { required: true })}
         defaultValue={DEFAULT_SLOT_BOOKING_LEAD_PERIOD_IN_HOURS}
         stepValue={SHORT_ADVANCE_BOOKING_DURATION_STEP}
         min={SHORT_ADVANCE_BOOKING_DURATION_MIN_VALUE}
         max={SHORT_ADVANCE_BOOKING_DURATION_MAX_VALUE}
         pattern={NumberPatternType.POSITIVE_INTEGER}
         label={settingsTranslationKeys.minimumLeadingPeriodInHours}
         labelNoWrap
      />
   );
};
